import { ca } from '@cian/analytics';
import { IRouteData, TRoutingMode } from '@cian/frontend-newbuilding-map-component';
import { toAnalyticsObjectType } from './toAnalyticsObjectType';

const WAY_MODE_MAP = new Map<TRoutingMode, string>([
  ['pedestrian', 'foot'],
  ['masstransit', 'public'],
  ['auto', 'car'],
]);

interface ISearchResult {
  mode: TRoutingMode;
  routes: IRouteData[];
  wayPoints: {
    address?: string;
    coordinates: [number, number];
    index: number;
  }[];
}

interface ITrackBuildRouteSuccessParams {
  isObjectPoint: boolean;
  infrastructureType?: string;
  searchResult: ISearchResult;
  isFutureObject: boolean;
  hasFutureInfrastructure: boolean;
  hasTransportAccessibilityService: boolean;
}

export const mapRequestParams = (searchResult: ISearchResult) => {
  const pointTo = searchResult.wayPoints.find(point => point.index === 1);

  return {
    address: pointTo ? pointTo.address : undefined,
    coordinates: pointTo ? pointTo.coordinates : undefined,
    way_type: WAY_MODE_MAP.get(searchResult.mode),
  };
};

export function trackBuildRouteSuccess({
  infrastructureType,
  searchResult,
  isObjectPoint,
  isFutureObject,
  hasFutureInfrastructure,
  hasTransportAccessibilityService,
}: ITrackBuildRouteSuccessParams) {
  let blockType: string;

  if (hasTransportAccessibilityService) {
    blockType = 'accessibility';
  } else if (hasFutureInfrastructure) {
    blockType = 'future';
  } else {
    blockType = 'standard';
  }

  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: 'build_route',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        object_type: toAnalyticsObjectType(infrastructureType),
        search_request: mapRequestParams(searchResult),
        search_results: searchResult.routes,
        route_cnt: searchResult.routes.length,
        type_in: !isObjectPoint,
        is_future_object: isFutureObject,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
